module.exports = __webpack_public_path__ + "static/media/X5-F.9e266af0.png";